<div class="modal-header">
    <span class="modal-header-title"> {{ 'ATTRIBUTES.EDIT_ATTRIBUTES' | translate }} </span>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
    </button>
</div>
<div class="modal-body">

    <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

        <div class="row">

            <div class="col-6">
                <div class="form-group">
                    <label class="filter-label" for="attribute_id"> {{ 'ATTRIBUTE' | translate }}</label>
                    <ng-select 
                    id="attribute_id" 
                    class="custom" 
                    clearAllText="{{ 'CLEAR' | translate }}" 
                    notFoundText="{{ 'NO_DATA' | translate }}"
                    bindLabel="name" 
                    placeholder="Выберите из списка"
                    formControlName="attribute" 
                    [multiple]="false" 
                    groupBy="attribute_group_name"
                    [items]="attributes">
                        <ng-template ng-option-tmp let-item="item">
                            <div [title]="item.name" class="item-name">{{item.name}}</div>
                        </ng-template>
                    </ng-select>
                    <div *ngFor="let item of errorMessages.attribute">
                        <div class="text-error" *ngIf="validation('attribute', item.type)">
                            {{ item.message | translate: item.options }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-6" *ngIf="attributesData != null">
                <div class="form-group value-filed">
                    <label class="filter-label" for="legal_form_id"> {{ 'NEW_VALUE' | translate }}</label>
                    <app-editable-content 
                    class="attr-text-info-edit"
                    [inputValue]="{attrsData: attributesData, productData: productsIds, defaultStyle: false}"
                    (outputValue)="updateList($event)">
                    </app-editable-content>
                    <div *ngFor="let item of errorMessages.attribute">
                        <div class="text-error" *ngIf="validation('attribute_value', item.type)">
                            {{ item.message | translate: item.options }}
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </form>


</div>

<div class="modal-footer btn-box">
    <button type="button" class="btn btn-light btn-sm btn-back" (click)="activeModal.dismiss(false)">
        {{ 'CLOSE' | translate}}
    </button>
    <button type="button" class="btn btn-primary btn-sm btn-create" (click)="onUpdate()" [disabled]="form.invalid">
        {{ 'SAVE'| translate}}
    </button>
</div>